// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  features/whatsapp/services/whatsappService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  EnviarWhatsAppRequest,
  EnvioWhatsAppResultado,
  ConexaoWhatsAppResultado,
  WhatsAppTemplate,
  SalvarWhatsAppTemplateRequest,
  ConfigWhatsApp,
  SalvarConfigWhatsAppRequest,
  WhatsAppMensagemLog,
} from '../types';

export const whatsappService = {
  // Envio
  enviar: (req: EnviarWhatsAppRequest) =>
    apiClient.post<EnvioWhatsAppResultado>('/api/whatsapp/enviar', req).then(r => r.data),

  testarConexao: () =>
    apiClient.get<ConexaoWhatsAppResultado>('/api/whatsapp/testar-conexao').then(r => r.data),

  historico: (params: { pessoaId?: number; numero?: string; tamanho?: number } = {}) =>
    apiClient.get<WhatsAppMensagemLog[]>('/api/whatsapp/historico', { params }).then(r => r.data),

  // Templates
  listarTemplates: () =>
    apiClient.get<WhatsAppTemplate[]>('/api/whatsapp/templates').then(r => r.data),

  criarTemplate: (req: SalvarWhatsAppTemplateRequest) =>
    apiClient.post<WhatsAppTemplate>('/api/whatsapp/templates', req).then(r => r.data),

  atualizarTemplate: (id: number, req: SalvarWhatsAppTemplateRequest) =>
    apiClient.put<WhatsAppTemplate>(`/api/whatsapp/templates/${id}`, req).then(r => r.data),

  excluirTemplate: (id: number) =>
    apiClient.delete(`/api/whatsapp/templates/${id}`).then(() => undefined),

  // Config
  getConfig: async (): Promise<ConfigWhatsApp | null> => {
    const r = await apiClient.get<ConfigWhatsApp>('/api/config/whatsapp', {
      validateStatus: (s) => s === 200 || s === 204,
    });
    return r.status === 204 ? null : r.data;
  },

  salvarConfig: (req: SalvarConfigWhatsAppRequest) =>
    apiClient.put<ConfigWhatsApp>('/api/config/whatsapp', req).then(r => r.data),
};
